export default {
  AccountPage: {
    address: 'Adresa',
    biometricLogin: {
      android: 'Prijava sa biometrijom',
      default: 'Prijava sa biometrijom',
      ios: 'Prijava sa biometrijom ili šifra'
    },
    biometricLoginDisabled: 'Biometrijska prijava onemogućena',
    biometricLoginEnabled: 'Biometrijska prijava omogućena',
    birthDate: 'Datum rođenja',
    customerReferenceNumber: 'Customer reference number',
    email: 'Email',
    gender: {
      FEMALE: 'Ženski',
      MALE: 'Muški',
      title: 'Spol'
    },
    generalInformation: 'Opće informacije',
    language: 'Izbor jezika',
    lastName: 'Last name',
    loansHistory: 'Istorijat kredita',
    logout: 'Odjavite se',
    middleName: 'Ime oca',
    name: 'Ime',
    phone: 'Telefon',
    pin: 'Jedinstveni matični broj',
    title: 'Moj račun',
    updatePhoneNumber: 'Ažurirajte svoj broj telefona'
  },
  BankTransferDisclaimerPage: {
    subtitle: 'Please visit our nearest branch so personal identification and account approval process may be completed.',
    title: 'Bank transfer'
  },
  Banner: {
    footnote: '* Da biste u potpunosti uživali u novim mogućnostima MyIute usluge, potrebno je prijaviti se sa vašim ličnim identifikacijskim brojem (PIN).',
    item: {
      1: 'Aplicirajte i upravljajte vašim kreditom online 24/7',
      2: 'Dobivajte personalizovane ponude',
      3: 'Plaćajte rate od kuće'
    },
    title: 'Upravljajte svojim kreditom dok ste u pokretu sa poboljšanom MyIute uslugom'
  },
  BiometricLoginError: {
    action: 'Go to phone settings',
    close: 'Ne sada',
    title: 'Nije moguće upotrijebiti biometrijsku prijavu, provjerite postavke telefona'
  },
  BiometricLoginPrompt: {
    close: 'Ne sada',
    enable: 'Omogući',
    title: {
      android: 'Želite li olakšati postupak prijave omogućavanjem prepoznavanja otiska prsta / lica? 😊',
      default: 'Želite li omogućiti biometrijsku prijavu?',
      ios: 'Želite li olakšati postupak prijave omogućavanjem prepoznavanja otiska prsta / lica ili korištenjem PIN-a? 😊'
    }
  },
  BottomNav: {
    contact: 'Kontakt',
    loans: 'Krediti',
    locations: 'Lokacije',
    mainSiteName: 'iutecredit.ba',
    mainSiteUrl: 'https://iutecredit.ba',
    mastercard: 'Card',
    my: 'MyIute',
    overview: 'Pregled'
  },
  BranchDetailsPage: {
    businessHours: 'Radno vrijeme',
    cashWithdrawal: 'Cash withdrawal',
    email: 'E-mail',
    phone: 'Kontakt telefon',
    viewOnMap: 'Pogledaj na karti'
  },
  BranchSelectionPage: {
    description: 'Your Mastercard is ready at any branch',
    title: 'Select Iute branch'
  },
  BranchesPage: {
    title: 'Podružnice'
  },
  CardAgreementSignedSuccessPage: {
    description: 'Your card is on its way. You will be contacted on the phone by the courier for time of delivery.',
    done: 'Done',
    title: 'Mastercard agreement signed'
  },
  CardContractSendPage: {
    cardTitle: 'Review the Mastercard contract',
    downloadDescription: 'You can also download the Mastercard contract'
  },
  CardCourierPage: {
    addNewAddress: 'Add new',
    apartment: 'Apartment',
    back: 'Back',
    cancel: 'Cancel',
    city: 'City',
    cityDistrict: 'City district',
    confirm: 'Confirm and order',
    enterAnotherAddress: 'Enter new address',
    houseNumber: 'House number',
    phone: 'Phone',
    pickAnotherAddress: 'Select other address',
    query: 'Search address',
    street: 'Street',
    title: 'Delivery details',
    zipCode: 'Zip code'
  },
  CardDeliverySelectionPage: {
    byCourier: 'Courier delivery',
    byCourierInfo: 'Will be delivered in 24 hours after card is ordered except Sunday',
    recommended: 'Recommended',
    subtitle: 'Choose a method to receive your new Mastercard',
    title: 'Get Mastercard',
    toBranch: 'Pick card from Iute branch',
    toBranchInfo: 'Find closest branch, card available immediately'
  },
  CardOrderConfirmationPage: {
    confirm: 'Confirm and order'
  },
  CardOrderSuccessPage: {
    address: 'Address',
    descriptionForBranch: 'Your choice for {branch} is taken, but you can still go and pick up the card at any of our branches 😊',
    descriptionForCourier: 'Your Mastercard order is taken, we will ask you to sign the Mastercard agreement before sending your card. Please stay tuned with us.',
    done: 'Done',
    title: 'Mastercard ordered'
  },
  CardPayoutSuccess: {
    description: 'Please check your Mastercard balance',
    done: 'Done',
    title: 'Your request is processed'
  },
  CashPalBanner: {
    applyNow: 'Apply now',
    body: 'Applying only takes 30 seconds',
    getAmount: '{name}, you can get your {amount} pre-approved loan limit right away!',
    title: 'Get money immediately!'
  },
  ConsentDocumentPage: {
    disclaimerFooter: 'In case of any disputes between the languages, Bulgarian version shall prevail',
    disclaimerHeader: 'English version after Bulgarian version',
    disclaimerSpecimen: 'English Specimen – for informational purposes only'
  },
  Contacts: {
    branches: 'Lokacije Podružnica',
    businessHours: 'Naša korisnička služba je dostupna u slijedećim terminima: PON-PET 08.00 – 19.00, SUB-NED 09.00 – 17.00',
    callUs: 'Pozovite nas',
    chat: 'Uđite na Chat sada',
    email: 'E-mail',
    facebook: 'Facebook',
    findUs: 'Pronađite nas',
    followUs: 'Pratite nas',
    instagram: 'Instagram',
    internet: 'Web stranica',
    linkedin: 'LinkedIn',
    mastercard: 'Mastercard <br/>(card blocking)',
    partners: 'Naši partneri',
    title: 'Kontaktirajte nas',
    viber: 'Viber',
    whatsapp: 'WhatsApp',
    youtube: 'Youtube'
  },
  ContractSendPage: {
    cardTitle: 'Pregledajte ugovor',
    download: 'Dowload ugovora',
    downloadDescription: 'Ugovor možete i downloadirati',
    email: 'E-mail',
    placeholder: 'Vaš e-mail',
    sendButton: 'Pošalji na e-mail',
    text: 'Šaljemo ugovor na Vašu e-mail adresu na pregled.',
    title: 'Pogledajte ugovor',
    wasSent: {
      message: 'Vaš ugovor je poslan na dostavljenu e-mail adresu',
      title: 'Uspješno'
    }
  },
  CreditLimit: {
    message: 'Sada imate kreditni limit od <strong>{amount}</strong>. Podnesite zahtjev sada putem ponude niže za brzo odobrenje!',
    title: 'Čestitamo!'
  },
  CustomerOverviewPage: {
    customerReferenceNumber: 'Customer reference number',
    noOffers: 'Trenutno nemamo novih ponuda za Vas.',
    title: 'MyIute',
    toApp: 'Go back to mobile application'
  },
  DatePicker: {
    day: 'dan',
    month: 'mjesec',
    placeholders: {
      day: 'DD',
      month: 'MM',
      year: 'YYYY'
    },
    year: 'godina'
  },
  ExternalPaymentsPage: {
    description: 'Izaberite najpogodniji način za plaćanje.',
    other: 'Druge opcije',
    recommended: 'Preporučeno',
    title: 'Načini plaćanja'
  },
  GeneralTermsPage: {
    title: 'Opći uslovi'
  },
  HomePage: {
    applyForALoan: 'Podnesite zahtjev za kredit',
    login: 'Prijavite se',
    selectLanguage: 'Odaberite jezik'
  },
  LoanAgreement: {
    actionPrivacyPolicy: 'Privacy Policy',
    agreeAndSubmit: 'Slažem se i prilažem',
    apr: 'APR',
    autoAgreement: {
      BASIC: 'Nastavkom potvrđujete da ste pročitali Obavijest o obradi ličnih podataka, Opće uslove, te da se slažete sa naprijed navedenim uslovima.',
      COMFORT: 'Nastavkom potvrđujete da ste pročitali Obavijest o obradi ličnih podataka, Pred-ugovor, Opće uslove, te da se slažete sa naprijed navedenim uslovima.'
    },
    campaignMonthlyPayments: 'Mjesečna otplata ako se prijavite u aplikaciju MyIute',
    consent: 'Saglasnost',
    creditRegistryConsent: 'Dajem svoju {action} MKD IuteCredit BH d.o.o. Sarajevo da provjeri moju kreditnu historiju na osnovu informacija pohranjenih u bazi podataka Centralnom kreditnom registru BiH i iskoristi dobijene podatke za procjenu moje kreditne sposobnosti.',
    eir: 'EKS',
    fees: 'Naknade',
    loanAmount: 'Iznos kredita',
    loanBalance: 'Amount to be refinanced',
    loanNumber: 'Loan reference number',
    loanPeriod: 'Period kredita',
    month: '0 mjeseci | 1 mjesec | {count} mjeseca | {count} mjeseci',
    monthlyPayments: 'Mjesečne rate',
    newsAgreement: 'Želim da primam ekskluzivne ponude putem SMS-a ili E-maila',
    newsAgreementLink: 'Read more',
    notice: 'Prije podnošenja zahtjeva za kredit savjetujemo Vam da razmotrite Vaše finansijske mogućnosti i dostavite nam tačne i relevantne podatke o Vašoj trenutnoj finansijskoj situaciji.',
    pep: 'Izjavljujem da nisam politički izložena osoba (PEP) {action}',
    pepConsentLink: 'Pročitajte više',
    personalDataProcessingConsent: 'I am informed and agree with the personal data processing principles as described in the {action}',
    preContract: 'Pred-ugovor',
    refinanceableAmount: 'Amount to be refinanced',
    refinanceDisclaimer: 'The loan/s below will be closed by signing the new contract and you will have only one loan in amount of {loanAmount}',
    requestedAmount: 'Requested loan amount',
    title: 'Provjerite uslove',
    totalPayment: 'Ukupno plaćanje',
    totalAmount: 'Final loan amount'
  },
  LoanApplicationCard: {
    extraCash: 'Extra cash',
    yourApplication: 'Vaš zahtjev za kredit'
  },
  LoanApplicationDetailsPage: {
    reference: 'Broj #{reference}',
    title: 'Zahtjev za kredit'
  },
  LoanApplicationThankYouPage: {
    close: 'Natrag na korištenje aplikacije',
    title: 'Uspješno ste aplicirali za kredit!<br/>Hvala!'
  },
  LoanApplicationTimeline: {
    addDocumentPhotos: 'Dodajte slike dokumenata',
    addMoreDocuments: 'Dodaj još',
    alternativeDealerSigningPlaces: 'Alternativno, svoj ugovor možete potpisati kod našeg partnera',
    alternativeRegularSigningPlaces: 'Alternativno, Vaš ugovor možete otpisati u nekoj od naših Podružnica {signingBranches}',
    amount: 'Iznos',
    applicationApproved: 'Zahtjev je odobren',
    applicationRejected: 'Zahtjev je odbijen',
    choosePayoutMethod: 'Izaberite način isplate kredita',
    continueToSigning: 'Nastavite na potpisivanje',
    contractSigned: 'Ugovor je potpisan',
    dealerLoanIsSigned: 'Dobili ste Vaš proizvod. Čestitamo!!',
    decision: 'Odluka',
    documentPhotosAdded: '0 slika dokumenata je dodano | 1 slika dokumenta je dodana | {count} slike dokumenata su dodane | {count} slika dokumenata su dodane',
    findSigningLocations: 'Potražite lokacije za potpis ugovora',
    loanPaidOut: 'Isplata kredita',
    month: '0 mjeseci | 1 mjesec | {count} mjeseca | {count} mjeseci',
    ncAddressMissing: 'One small step is left to finalize your loan signing, please contact us at 0700 40 111 😊',
    ncDocumentsMissing: 'You will be contacted for further information to proceed with your application',
    offeredAmount: 'Offered amount',
    offeredPeriod: 'Offered period',
    payoutAmount: 'Iznos za isplatu',
    payoutLocations: 'Vidite lokacije za isplatu',
    payoutMethod: {
      abi: 'Sredstva možete preuzeti u poslovnici Pošta Srpske',
      atm: 'All set. You can now receive your cash at IuteCredit ATM.',
      bank: 'Sredstva možete preuzeti putem Vašeg bankovnog računa',
      bpay: 'All set. You can now receive your cash at Bpay ATM',
      card: 'All set. You can now receive your cash on every ATM in the country and abroad',
      cash_distribution: 'All set. You can now receive your cash at bank',
      easy_pay: 'All set. You can now receive your cash at EasyPay',
      paynet: 'All set. You can now receive your cash at Paynet operator',
      posta: 'Sredstva možete preuzeti u poslovnici JP BH Pošte',
      raefaes: 'All set. You can now receive your cash at any RAEAFS office',
      refinanced: 'Your loan is refinanced',
      restructured: '',
      victoria_bank: 'All set. You can now receive your cash at bank',
      western_union: 'All set. You can now receive your cash at any Western Union office'
    },
    period: 'Period',
    reason: 'Razlog',
    receiveContract: 'Primite ugovor',
    referenceNumber: 'Broj ugovora o kreditu',
    refinanceableAmount: 'Amount to be refinanced',
    rejectionReason: {
      REJECTED: 'Nažalost, ne možemo prihvatiti Vaš zahtjev u ovom trenutku. Molimo posjetite nas opet u budućnosti.',
      WITHDRAWN: 'Žao nam je, Vaš zahtjev je povučen. Ukoliko budete željeli podnijeti novi zahtjev, molimo prijavite se na aplikaciju ili nas kontaktirajte putem našeg kontakt centra za korisnike, ili nas posjetite u nekoj od naših Podružnica.'
    },
    signWithPhone: 'Potpišite putem Vašeg telefona, potrebno je samo nekoliko trenutaka.',
    signingBranches: 'IuteCredit Podružnice.',
    signingLocation: {
      abi: 'Vaš Ugovor za kredit možete potpisati u bilo kojoj Poslovnici Pošta Srpske',
      call: 'You may sign your contract by calling at +355 44505060',
      dealer: 'You may sign your contract at dealer shop.',
      easy_pay: 'You may sign your contract at EasyPay',
      office: 'Vaš Ugovor za kredit možete potpisati u bilo kojoj Podružnici IuteCredit BH',
      online: 'You may sign your contract via Sms.',
      posta: 'Vaš Ugovor za kredit možete potpisati u bilo kojoj Poslovnici JP BH Pošte',
      raefaes: 'You may sign your contract at the Raeafs',
      shop: 'You may sign your contract at any of the IuteCredit partners. Please contact us at +355 44505060, for further information.',
      sms: 'You may sign your contract via Sms.',
      western_union: 'You may sign your contract at the Western Union'
    },
    status: {
      APPROVED: 'Potpis',
      COMPLETED: 'Detalji kredita će se pojaviti uskoro',
      REJECTED: 'Zahtjev je odbijen',
      REVIEW: 'Zahtjev je u razmatranju',
      SIGNED: 'Preuzmite sredstva',
      SUBMIT: 'Zahtjev je zaprimljen',
      VERIFICATION: 'Potvrda identiteta',
      WITHDRAWN: 'Zahtjev je povučen'
    },
    submitted: 'Priloženo',
    uploadPhotosOfIdCard: 'Uploadirajte Vašu ličnu kartu, kako biste ubrzali proces odobravanja kredita.',
    verificationFailed: 'Ne možemo potvrditi vaš identitet, molimo posjetite našu podružnicu 😒',
    verificationFailedForDealer: 'Ne možemo potvrditi Vaš identitet 😒 Naš partner će Vas kontaktirat da biste nastavili s identifikacijom i potpisivanjem',
    verificationFindLocations: 'Pronađite lokacije',
    verificationIsDone: 'Verifikacija je završena',
    verificationIsInProgress: 'Verifikacija je u toku. Obavijestiti ćemo Vas kada bude okončana.',
    verificationIsNotSupported: 'Molim Vas poražite Vama najbližu Podružnicu radi Vaše identifikacije',
    verificationIsNotSupportedInDesktop: 'Preuzmite aplikaciju kako biste nastavili sa provjerom identifikacije i potpisivanjem kredita',
    verificationShouldTakeShortTime: 'Ovo će potrajati samo par minuta',
    verificationStart: 'Započnite verifikaciju',
    verificationTitle: 'Molim dozvolite da potvrdimo Vaš identitet radi potpisivanja ugovora o kreditu.',
    youCanNowChoosePayoutMethod: 'Možete izabrati kako želite da Vam se doznače sredstva kredita',
    youMayBeContacted: 'Bićete kontaktirani za dodatne informacije kako bismo mogli nastaviti sa obradom Vašeg zahtjeva.',
    yourLoanIsRestructured: 'Vaš kredit je restrukturiran',
    youWillReceive: 'Amount to be received'
  },
  LoanCard: {
    closeDate: 'Datum okončanja kredita',
    extraCash: 'Extra cash',
    finalDueAmount: 'Konačni dospjeli iznos',
    loanAmount: 'Iznos kredita',
    nextPaymentDays: 'Danas | Sutra | Slijedeća uplata za {count} dana | Slijedeća uplata za {count} dana',
    overdueDays: '0 dana kašnjenja | 1 dan kašnjenja | {count} dana kašnjenja | {count} dana kašnjenja',
    payNow: 'Platite sada',
    reference: 'Refinansirajte',
    remaining: 'Ostatak',
    repayNow: 'Platite sada',
    startDate: 'Datum početka kredita'
  },
  LoanClosureConfirmationPage: {
    loanEndDate: 'Datum zatvaranja Ugovora',
    reference: 'Broj kredita',
    title: 'Potvrda o zatvaranju kredita'
  },
  LoanDefaultedMessage: {
    REGULAR: {
      description: 'Možete platiti ovdje ili nas pozovite na +387 33 257 666 ili +387 51 981 330 da biste napravili dogovor u vezi sa plaćanjem kredita.',
      title: 'Vaš Ugovor o mikrokreditu je raskinut radi kašnjenja u plaćanju više od dvije rate.'
    },
    RESTRUCTURED: {
      description: '',
      title: 'Vaš kredit je restrukturiran.'
    },
    WRITTEN_OFF: {
      description: 'Možete platiti ovdje ili nas pozovite na +387 33 257 666 ili +387 51 981 330 da biste napravili dogovor u vezi sa plaćanjem kredita.',
      title: 'Vaš Ugovor o mikrokreditu je raskinut radi kašnjenja u plaćanju više od dvije rate.'
    }
  },
  LoanDetailsPage: {
    apr: 'APR',
    closureCertificate: 'Preuzmite potvrdu o otplati kredita',
    contract: 'Prijem Ugovora',
    documents: 'Dokumenti',
    fees: 'Naknade',
    finalDueAmount: 'Konačni dospjeli iznos',
    interestRate: 'Efektivna kamatna stopa',
    loanAmount: 'Iznos kredita',
    loanEnd: 'Kraj kredita',
    loanPeriod: 'Trajanje kredita',
    loanRepayEarlier: 'Otplatite kredit ranije',
    loanStart: 'Početak kredita',
    month: '0 Mjeseci | 1 Mjesec | {count} Mjeseca | {count} Mjeseci',
    nextPayment: 'Sljedeće plaćanje',
    nextPaymentDays: 'Danas | Sutra | Za {count} dana | Za {count} dana',
    overdueDays: '0 dana kašnjenja | 1 dan kašnjenja | {count} dana kašnjenja | {count} dana kašnjenja',
    paidAmount: 'Uplaćeni iznos',
    payNow: 'Platite sada',
    paymentSchedule: 'Otplatni plan',
    payoutMethod: 'Način plaćanja',
    payoutMethods: {
      abi: 'Pošte Srpske',
      atm: 'ATM',
      bank: 'Banka',
      bcr: 'Banca Comerciala Română Chişinău S.A.',
      bkt: 'Banka Kombetare Tregtare (BKT)',
      bpay: 'Bpay',
      card: 'Card',
      commert: 'BC COMERŢBANK S.A.',
      credins: 'Credins Bank',
      crm_refin: 'Loan refinancing',
      crm_restructured: 'Loan restructuring',
      dealer: 'Dealer partner',
      easy_pay: 'Easy Pay',
      eurocredit: 'BC EuroCreditBank S.A.',
      exim: 'BC Eximbank S.A.',
      intesa: 'Intesa San Paolo Bank',
      moldindcon: 'BC Moldindconbank S.A.',
      moldindcon_bank: 'BC Moldindconbank S.A.',
      paynet: 'Paynet',
      posta: 'BH Pošte',
      qiwi: 'Qiwi',
      raefaes: 'RAEFS',
      raiffeisen: 'Raiffeisen Bank',
      refinanced: 'Refinansiranje',
      restructured: 'Restruktura',
      runpay: 'RunPay',
      victoria: 'BC Victoribank S.A.',
      victoria_bank: 'BC Victoribank S.A.',
      western_union: 'Western Union'
    },
    referenceNo: 'Broj {referenceNo}',
    remainingBalance: 'Preostali iznos',
    repayNow: 'Platite sada',
    suspendInstallment: 'Odgodite ratu',
    title: 'Podaci o kreditu',
    toBePaid: 'Potrebno platiti',
    whatIfLatePayment: 'Kakvi su uvjeti ako zakasnim sa plaćanjem?'
  },
  LoanFormPage: {
    accessFeeDisclaimer: 'Naknada za obradu kredita uračunata je u ukupni trošak naknada, a <strong>iznos od {amount} BAM naknade za obradu kredita</strong> biti će umanjena prije isplate od ukupnog iznosa kredita',
    apply: 'Podnesite zahtjev sada!',
    applyPal: 'Apply now and get instant approval!',
    apr: 'APR',
    campaignConditionsNC: 'Loan conditions displayed below is our discounted offer and is only valid for customers signing their agreements on MyIute',
    campaignConditionsNewCustomer: 'Mjesečna otplata ako se prijavite u aplikaciju MyIute',
    campaignConditionsReturningCustomer: 'Mjesečna otplata ako se prijavite u aplikaciju MyIute',
    campaignDiscount: 'Sign loan agreement digitally, save trees and receive discount of ',
    discountedMonthlyPayments: 'Discounted monthly repayment',
    eir: 'EKS',
    forMonths: 'Za 0 mjeseci | Za 1 mesec | Za {count} mjeseca | Za {count} mjeseci',
    interestRate: 'EKS',
    loanAmount: 'Iznos kredita',
    loanDisclaimer: 'Iznos mjesečne rate i rok kredita su prikazani u demonstrativne svrhe.  Nakon podnošenja zahtjeva za kredit naši savjetnici za klijente će Vas kontaktirati kako bi Vam ponudili kredit koji će odgovarati Vašim potrebama u cilju kompletiranja procesa podnošenja zahtjeva.Upoznajte se sa {tc}.',
    loanPeriod: 'Rok kredita',
    loanRepaymentDay: 'Loan repayment day',
    month: '0 mjeseci | 1 mjesec | {count} mjeseca | {count} mjeseci',
    monthlyPaymentDisclaimer: 'Monthly repayment shown above and fee total below take into account your other active loan/s. In the case of loan approval, all loans will be merged into one.',
    monthlyPaymentsFrom: 'Mjesečna rata od',
    palLoanActive: 'You will get this amount instantly!',
    returningCustomerNotice: 'Kao naš cijenjeni klijent, Vi ostvarujete prava na povoljnije uvjete. Mi cijenimo naš poslovni odnos.',
    signYourself: 'Less paper, greener nature.',
    termsAndConditions: 'Opći uslovi',
    title: 'Podnesite zahtjev za kredit',
    totalFees: 'Naknade ukupno',
    upTo: 'Do {count}',
    zeroCostFor30Days: '0% trošak do 30 dana'
  },
  LoanFullRepaymentPage: {
    adminFee: 'Naknada za administriranje kredita',
    disclaimerFooter: 'Clicking on the button does not bring you additional liabilities. If the amount is not paid on the day mentioned below, loan instalments will continue as they are.',
    disclaimerHeader: 'Unless button is pressed, the amount shown above will not be saved. To proceed with early repayment process, please click on the button below.',
    guaranteeFee: 'Naknada za garanciju',
    interest: 'Kamata',
    message1: 'Da li ste spremni otplatiti cjelokupan iznos duga odmah? Prijevremena otplata duga ima svojih prednosti!',
    message2: 'Ukoliko otplatite cjelokupan iznos duga dana {date}, sljedeće bi bile Vaše uštede:',
    newRemainingBalance: 'Ukupan iznos koji je potrebno uplatiti',
    payLoanNow: 'Platite kredit sada',
    pendingRepayment: 'You already have pending loan full repayment initiated. You have time to pay {amount} until {date}',
    remainingBalance: 'Ostatak duga',
    title: 'Otplatite kredit ranije',
    youWillPayMore: 'You will pay additionally (unfortunately, no rewards this time ☹)',
    yourTotalSavings: 'Vaša ukupna ušteda'
  },
  LoanOverdueMessage: {
    paymentIsOverdue: 'U kašnjenju ste s plaćanjem.<br>Molimo platite odmah!'
  },
  LoanPaymentCalculatorPage: {
    anErrorHappened: 'Došlo je do greške u izračunu. Molimo pokušajte kasnije',
    lateMessage: 'U kašnjenju ste sa otplatom duga.  Molimo Vas uplatite <strong>{amount}</strong>.',
    latePaymentMessage: 'Na današnji dan u obavezi ste platiti:',
    onTime: 'na vrijeme, {date}',
    onTimeMessage: 'Nikakve naknade se ne primjenjuju u slučaju redovne otplate. Očekujemo da uplatite <strong>{amount}</strong>.',
    primaries: 'Naknade',
    principal: 'Glavnica',
    secondaries: 'Kazne',
    title: 'Izračunajte iznos naredne uplate',
    totalDept: 'Iznos sljedeće uplate',
    whenDoYouWantToPay: 'Kada želite izvršiti plaćanje?'
  },
  LoanPaymentSchedulePage: {
    currentDebt: 'Current debt',
    delayInterest: 'Delay interest: {delayInterest}',
    nextPaymentAmount: 'Next payment amount',
    nextPaymentDate: 'Sljedeće plaćanje',
    nextRepaymentAmount: 'Next repayment amount',
    paymentOverdue: 'Kašnjenje u otplati',
    payments: 'Broj rata / Broj uplaćenih rata',
    paymentsNC: 'Broj uplaćenih rata / Broj rata',
    paymentsSchedule: 'Otplatni plan',
    penalties: 'Kazne {penaltiesAmount}',
    referenceNumber: 'Broj kredita',
    remainingBalance: 'Ostatak duga',
    repaymentDate: 'Repayment date',
    sendToEmail: 'Send to email',
    showInstallments: 'Show installments',
    suspendInstallment: 'Odgađanje rate',
    suspendedUntil: 'Odgođeno plaćanje do {suspendedUntil}',
    suspensionFee: 'Naknada za odgađanje rate {suspensionFee}',
    totalPaid: 'Ukupna uplata {paidAmount}',
    totalToBePaid: 'Ukupan iznos za uplatu',
    totalUnpaid: 'Za plaćanje {unpaidAmount}'
  },
  LoanRequestSuspensionPage: {
    newPaymentDate: 'Novi datum uplate',
    paymentAmount: 'Iznos uplate',
    paymentDate: 'Datum uplate',
    requestSuspension: 'Zahtjev za odgodu rate',
    suspensionFee: 'Naknada za odgodu rate',
    suspensionNotAvailable: 'Odgoda rate nije moguća u ovom trenutku. Molimo pozovite naš kontakt centar na +387 33 257 666 ili +387 51 981 330 da biste saznali više.',
    suspensionNotice: 'Razumijemo da postoje prilike kada niste u mogućnosti da izvršite uplatu na vrijeme Ovdje smo da Vam ponudimo mogućnost da odložite Vaše uplate. \n\n Molimo razmotrite pažljivo detalje zahtjeva za odgodom rate niže, prije nego podnesete zahtjev.\n\nU slučaju neplaćanja rate na vrijeme, primjenjuju se penali za kašnjenje.',
    title: 'Odgodite ratu'
  },
  LoanStepContactsPage: {
    alreadyHaveALoanWithUs: '<strong>Već imate kredit kod nas?</strong>',
    birthDate: 'Datum rođenja {birthDate}',
    continueBtn: 'Nastavite...',
    email: 'E-mail adresa',
    firstName: 'Ime',
    lastName: 'Prezime',
    logIn: 'Prijavite se',
    middleName: 'Ime oca',
    personalCode: 'Jedinstveni matični broj',
    phone: 'Telefon',
    phoneHint: 'Mora započinjati sa 06 i sastojati se od 9 ili 10 karaktera',
    title: 'Lične informacije'
  },
  LoanTerms: {
    personalDataProcessing: 'Obavijest o procesuiranju ličnih podataka',
    termsAndConditions: 'Uslovi'
  },
  LoanUnpaidMessage: {
    paymentIsUnpaid: 'Immediately due'
  },
  LoansPage: {
    status: {
      CLOSED: 'Zatvoreno',
      DEFAULTED: 'Krediti u kašnjenju preko ograničenja',
      DELAYED: 'U kašnjenju',
      NORMAL: 'Normalno stanje',
      PENDING: 'U toku',
      REFUNDED: 'Refinansirano',
      REJECTED: 'Odbijen zahtjev',
      WITHDRAWN: 'Povučen zahtjev'
    },
    title: 'Moji krediti'
  },
  LocationsPage: {
    branches: 'Podružnice',
    partners: 'Naši partneri'
  },
  LoginOtpPage: {
    anyOfOurBranches: 'bilo koju od naših Podružnica',
    phoneNumberNotValidPleaseVisit: 'Ukoliko broj telefona gore nije tačan, molimo posjetite'
  },
  LoginOtpReturningCustomer: {
    hasOffer: {
      message: 'Dopušten Vam je pristup, kako biste mogli uživati u prednostima naših ponuda.',
      title: 'Čini se da imate otvoren račun kod nas &nbsp;😀'
    },
    ncReturningCustomer: {
      message: 'Please enter OTP to access MyIute&nbsp;😀',
      title: 'It seems that you have an account with us'
    },
    withUsedOffer: {
      message: 'Preusmjeravamo Vas na Vaš račun',
      title: 'Imate otvoren račun kod nas'
    }
  },
  LoginPage: {
    fallbackLinkTitle: 'Podnesite zahtjev za kredit',
    fallbackMessage: 'Nemate račun? {fallbackLink} da biste kreirali račun.',
    logIn: 'Prijavite se',
    messageForExistingCustomer: 'Već ste imali poslovni odnos sa nama? Molimo prijavite se sa Vašim Jedinstvenim matičnim brojem.',
    pin: 'Jedinstveni matični broj',
    title: 'Prijavite se'
  },
  MaintenancePage: {
    title: 'MyIute is under maintenance. Please visit us soon.'
  },
  MastercardPage: {
    noRecentTransactions: 'No transactions in the last 30 days',
    title: 'Mastercard',
    validThru: 'Valid thru',
    yourLoanBalance: 'Your card balance'
  },
  Offer: {
    applyButton: 'Podnesite zahtjev sada'
  },
  Offers: {
    title: {
      generic: 'Ponude',
      personal: 'Lične ponude',
      promotions: 'Promocije'
    }
  },
  Otp: {
    incorrectOtp: 'Neispravan kod, molimo pokušajte ponovno',
    pleaseEnterCode: 'Molimo unesite kod niže',
    resend: 'POŠALJI PONOVNO',
    smsSent: 'SMS sa <br/>kodom je poslan na <br/>xxxxxxxxx-{phoneNumber}'
  },
  PalCard: {
    btn: {
      cash: 'Get as cash',
      qr: 'Scan IutePay QR',
      shop: 'Use in shops'
    },
    title: 'Your spending limit'
  },
  PalPartnersPage: {
    title: 'Where can I use my spending limit?'
  },
  PartnerDetailsPage: {
    businessHours: 'Radno vrijeme',
    email: 'E-mail',
    phone: 'Kontakt telefon',
    viewOnMap: 'Pogledaj na karti'
  },
  PartnersPage: {
    title: 'Naši partneri'
  },
  PaymentPartners: {
    description: {
      addiko: 'Addiko Bank d.d.',
      asa: 'ASA Banka d.d.',
      bosna: 'Bosna Bank International d.d.',
      intesa: 'Intesa Sanpaolo Banka d.d.',
      nlb: 'NLB Banka d.d.',
      privredna: 'Privredna Banka Sarajevo d.d.',
      raiffeisen: 'Raiffeisen Bank d.d.',
      sberbank: 'Sberbank d.d.',
      sparkasse: 'Sparkasse Bank d.d.',
      unicredit: 'UniCredit Bank d.d.',
      ziraat: 'Ziraat Bank d.d.'
    }
  },
  PaymentRedirectPage: {
    amount: 'Iznos',
    cin: 'CIN',
    completeYourRepayment: 'Izvršite plaćanje i vidjećete ga odmah na Vašem MyIute računu',
    copy: 'Kopirajte',
    fiscalCode: 'ID broj MKD IUTECredit BH',
    iban: 'Bankovni račun za uplatu',
    loanReferenceNumber: 'Broj kredita',
    makePayment: 'Izvršite plaćanje',
    openWebsite: 'Idite na website',
    valueCopied: 'Kopirano {value}'
  },
  PreContractSendPage: {
    download: 'Download pred-ugovora',
    downloadDescription: 'Pred-ugovor možete i downloadirati',
    email: 'E-mail',
    placeholder: 'Vaš e-mail',
    sendButton: 'Pošalji na e-mail',
    title: 'Prihvatite pred-ugovor na pregled na Vašu e-mail adresu',
    wasSent: {
      message: 'Vaš pred-ugovor je poslan na dostavljenu e-mail adresu',
      title: 'Uspješno'
    }
  },
  PrivacyPolicyPage: {
    title: 'Privacy policy'
  },
  Promotion: {
    showMore: 'Pročitajte više'
  },
  PromotionRedirectPage: {
    openWebsite: 'Idite na website',
    title: 'Promocija'
  },
  QrScanPage: {
    cameraPermissionNotGranted: 'Camera permission not granted',

    description: 'Find a IutePay QR code in {action} to pay in parts',
    instruction: 'Look for a QR code with IutePay Logo, scan the code with your mobile phone camera. By scanning the QR code, you can start paying in parts in our partner store.',
    loading: 'Loading...',
    palPartnersLink: 'partner stores',
    title: 'Scan a IutePay QR',
    unsupportedQrCode: 'IutePay does not support this QR code'
  },
  RepaymentBalance: {
    yourRepaymentBalance: 'Your repayment balance'
  },
  SendDocumentForm: {
    closure: {
      send: 'Pošaljite potvrdu',
      text: 'Preuzmite potvrdu kojom se potvrđuje da ste izmirili ostatak duga.',
      wasSent: {
        message: 'Vaša potvrda o izmirenju duga je poslana na dostavljenu e-mail adresu.',
        title: 'Uspješno'
      }
    },
    email: 'E-mail adresa',
    installments: {
      send: 'Pošalji plan',
      text: 'Preuzmite detaljan plan otplate koji sadrži podatke o svakoj rati.',
      wasSent: {
        message: 'Vaš plan otplate je poslan na dostavljenu e-mail adresu',
        title: 'Uspješno'
      }
    },
    yourEmail: 'Vaša e-mail adresa'
  },
  SignCardAgreementOtpPage: {
    signingAgreement: 'You are about to sign a card agreement:',
    warning: 'By signing the card agreement with the one-time-password sent to my verified phone number, I acknowledge and confirm to be legally bound by the foregoing terms.'
  },
  SignCardContractPage: {
    description: 'To proceed, send the contract to your e-mail for reviewing. After reading and agreeing with it you can sign it using your mobile device.',
    signContract: 'Sign the Mastercard contract',
    title: 'Sign Mastercard contract'
  },
  SignContractPage: {
    authenticationFailedError: 'Biometrijska provjera autentičnosti nije uspjela',
    description: 'Pošaljite ugovor na Vašu e-mail adresu radi pregleda.  Nakon čitanja i Vaše saglasnosti ugovor možete potpisati ovdje.',
    download: 'Dowload ugovora',
    downloadDescription: 'Ugovor možete i downloadirati',
    email: 'E-mail adresa',
    emailPlaceholder: 'Vaša e-mail adresa',
    notAvailableError: {
      android: 'Biometrija nije dostupna',
      default: 'Biometrija nije dostupna',
      ios: 'Biometrija (ili šifra) nije dostupna'
    },
    reviewContract: 'Pregledajte ugovor',
    send: 'Pošaljite na e-mail adresu',
    sign: 'Potpišite',
    signContract: 'Potpišite ugovor',
    signHintOtp: 'Kod za potvrdu će biti poslan na Vaš telefon',
    signHintPki: 'Vaš telefon će zatražiti da izvršite Vašu potvrdu',
    title: 'Potpišite ugovor',
    wasSent: {
      message: 'Vaš ugovor je poslan na dostavljenu e-mail adresu',
      title: 'Uspješno'
    }
  },
  SignLoanApplicationOtpPage: {
    signingContract: 'Sada ćete potpisati ugovor:',
    warning: 'Potpisivanjem ugovora o kreditu korištenjem jednokratnog koda poslanog na moj potvrđeni broj telefona, potvrđujem svoju saglasnost na dostavljene pravno obavezujuće uvjete.  Molim Vas da budete svjesni da kada je dostavljeni kod unijet, kredit će biti aktiviran.'
  },
  SignMastercardAgreement: {
    continueToSigning: 'Continue to signing',
    mastercard: 'Mastercard',
    signWithPhone: 'There is only one step left to start card delivery to you. Please review and sign Mastercard agreement and you will soon receive your card 😊'
  },
  SplashScreen: {
    connectingToServer: 'Povezivanje sa serverom...'
  },
  SurveyPage: {
    answerIsRequired: 'Molimo odaberite odgovor',
    appreciation: 'Cijenimo Vašu pomoć',
    backToApp: 'Natrag na korištenje aplikacije',
    skip: 'Preskoči za sada',
    submit: 'Pošalji odgovor',
    thankYou: 'Hvala!'
  },
  TopNav: {
    back: 'Natrag'
  },
  UpdateAccountPage: {
    accountUpdated: 'Podaci o računu ažurirani',
    phone: 'Telefon',
    phoneHint: 'Mora započinjati sa 06 i sastojati se od 9 ili 10 karaktera',
    saveChanges: 'Potvrdi',
    title: 'Ažurirajte svoj broj telefona'
  },
  UploadPage: {
    documentPhoto1: 'Slika dokumenta 1',
    documentPhoto2: 'Slika dokumenta 2',
    idCardBack: 'Poleđina lične karte <br> Nije potrebno za pasoš',
    idCardFront: '<strong>Lična karta - prednja strana</strong><br>ili stranica u putnoj ispravi sa fotografijom',
    takePhotosOfIdCard: 'Molimo Vas uslikajte Vašu <strong> ličnu kartu </strong> ili <strong> pasoš </strong> i uploadirajte ih.',
    upload: 'Uploadirajte',
    uploadDocumentPhotos: 'Uploadirajte slike dokumenata',
    uploading: 'Uploadiranje u toku...'
  },
  WalletBalance: {
    newLoan: 'New loan',
    recentTransactions: 'Recents',
    showAllTransactions: 'Show all',
    withdraw: 'Withdraw',
    yourLoanBalance: 'Your wallet balance'
  },
  WalletTransactionDetailsPage: {
    amount: 'Amount',
    description: 'Description',
    time: 'Transaction time',
    title: 'Transaction details',
    today: 'Today',
    yesterday: 'Yesterday'
  },
  WalletTransactionsPage: {
    title: 'Transactions'
  },
  WalletWithdrawalPage: {
    atm: {
      amountInfo: 'You can withdraw {amount}.',
      subtitle: 'Find nearest Iute ATM',
      title: 'Get Cash from Iute ATM'
    },
    bank: {
      amountInfo: 'You can withdraw {amount}.',
      subtitle: 'Transfers available only to your accounts',
      title: 'Bank transfer'
    },
    conditions: 'All fees related to approved loan payout are included and at any time available on ',
    conditionsUrl: 'https://iutecredit.bg/about/conditions',
    easypay: {
      subtitle: 'Bulgarian payment provider',
      title: 'EasyPay'
    },
    existingMastercard: {
      amountInfo: 'You can withdraw {amount}.',
      title: 'Transfer money to your Mastercard'
    },
    mastercard: {
      title: 'Get IuteCredit Mastercard'
    },
    newMastercard: {
      amountInfo: 'You can withdraw {amount}.',
      title: 'Get IuteCredit Mastercard'
    },
    subtitle: 'Choose where to transfer your money.',
    title: 'Withdraw money'
  },
  WithdrawalAtmPage: {
    subtitle: 'Find the closest Iute ATM near you',
    title: 'Iute ATM cash withdrawal'
  },
  WithdrawalBankTransferPage: {
    amount: 'Amount',
    bankAccount: 'Bank account of {name}',
    bankAccountHelp: '15 digits, for example, 250120000058984',
    bankAccountPlaceholder: '012345678901234',
    confirm: 'Confirm',
    continue: 'Continue',
    disclaimer: 'I hereby state and declare that the provided bank account number is mine and IuteCredit Bulgaria can use any mean deemed necessary to validate it',
    firstName: 'First name',
    lastName: 'Last name',
    subtitle: 'You are only allowed to transfer money to yourself',
    title: 'New bank transfer',
    yourLoanBalance: 'Your wallet balance: {amount}'
  },
  WithdrawalEasypayPage: {
    amount: 'Amount',
    confirm: 'Confirm',
    continue: 'Continue',
    subtitle: 'Easypay account must be associated with {name}, {pin}',
    title: 'Payout to Easypay',
    yourLoanBalance: 'Your wallet balance: {amount}'
  },
  WithdrawalEasypaySuccessPage: {
    done: 'Done',
    payoutRequestIsBeingProcess: 'Your request is being processed',
    sentTo: 'Initiated payout to {name}'
  },
  WithdrawalMastercardPage: {
    confirm: 'Confirm',
    disclaimer: '',
    signAgreement: 'Sign a card agreement',
    signAgreementDisclaimer: 'This card requires a new card agreement. Sign the new agreement to allow withdrawal.',
    subtitle: 'Select Mastercard for payout',
    title: 'Withdraw to Mastercard'
  },
  WithdrawalSuccessPage: {
    bankAccount: 'Bank account number',
    bankTransfer: 'Bank transfer',
    done: 'Done',
    payoutRequestIsBeingProcess: 'Your request is being processed',
    reference: 'Reference',
    sentTo: 'Initiated withdrawal to {name}'
  },

  biometry: {
    cardAgreement: {
      cancel: 'Sign using SMS',
      description: 'By signing this agreement using your biometric credentials you acknowledge that no biometric data will be processed by us',
      subtitle: 'Sign using your biometric credential',
      title: 'Sign the card agreement'
    },
    createCertificate: {
      cancel: 'Potpišite SMS-om',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'New IuteID'
    },
    login: {
      cancel: 'Ne sada',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'Prijavite se'
    },
    loginSetup: {
      cancel: 'Ne sada',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'New IuteID'
    },
    signLoanContract: {
      cancel: 'Potpišite SMS-om',
      description: 'Potpisivanjem ovog sporazuma koristeći Vaše biometrijske kredencijale potvrđujete da razumijete da mi nećemo obrađivati nikakve biometrijske podatke',
      subtitle: 'Potpišite se pomoću svojih biometrijskih kredencijala',
      title: 'Potpišite ugovor o kreditu'
    },
    updateAccount: {
      cancel: 'Ne sada',
      description: '',
      subtitle: 'Authenticate using your biometric credential',
      title: 'Potvrdite promjenu broja telefona'
    }
  },
  errors: {
    alreadySigned: {
      content: 'Please go to the main screen',
      title: 'Contract is already signed'
    },
    application: {
      content: 'Molimo kontaktirajte našu podršku za klijente na +387 33 257 666 ili +387 51 981 330.',
      title: 'Zahtjev nije moguće podnijeti'
    },
    biometry: {
      content: 'Molimo pokušajte ponovno.',
      title: 'Biometrijska provjera autentičnosti nije uspjela'
    },
    les: {
      1: 'Molimo unesite ispravan broj telefona i pokušajte ponovno',
      2: 'Prazno ili nekorektno polje za PEP saglasnost',
      3: 'Prazno ili nekorektno polje za GDPR saglasnost',
      4: 'Prazno ili nekorektno polje za iznos kredita',
      5: 'Prazno ili nekorektno polje za rok kredita',
      6: 'Molimo unesite ispravan datum rođenja',
      7: 'Molimo unesite Vaše puno ime',
      8: 'Molimo unesite Vaše puno prezime',
      9: 'Unijeli ste neispravan Jedinstveni matični broj. Molimo pokušajte ponovno',
      10: 'Prazno ili nekorektno polje za saglasnost',
      101: 'Molimo unesite ispravan broj telefona i pokušajte ponovno',
      102: 'Molimo unesite ispravan broj telefona i pokušajte ponovno',
      103: 'Molimo unesite ispravan Jedinstveni matični broj i pokušajte ponovno',
      104: 'Molimo unesite ispravan datum rođenja',
      105: 'Molimo unesite ispravan datum rođenja',
      106: 'Molimo unesite ispravan datum rođenja',
      107: 'Molimo unesite ispravnu e-mail adresu',
      108: 'Rok kredita je prekratak',
      109: 'Rok kredita je predugačak',
      110: 'Neispravna kopija lične karte – prednja strana',
      111: 'Neispravna kopija lične karte – zadnja strana',
      112: 'Neispravan broj bankovnog računa',
      113: 'Molimo unesite vaše puno ime',
      114: 'Molimo unesite vaše puno prezime',
      115: 'Neispravno uneseno ime',
      116: 'Molimo unesite ispravno ime roditelja i pokušajte ponovno',
      117: 'Neispravno ime alternativnog kontakta',
      118: 'Neispravan iznos kredita',
      119: 'Neispravan rok kredita',
      200: 'Kreditni proizvod nije pronađen!',
      201: 'Imate postojeći zahtjev za kredit kod ICBH.  Molimo koristite prijavu za pristup vašem korisničkom računu i pronađite svoju aplikaciju.',
      202: 'Imate postojeći korisnički račun kod ICBH.  Molimo koristite prijavu za pristup vašem korisničkom računu i podnesite zahtjev za kredit.'
    },
    loginFailed: {
      content: "Da li već imate račun kod nas. Molimo posjetite homepage i koristite 'Apply for a loan' dugme.",
      title: 'Neuspješna prijava'
    },
    newLoanNotAvailable: {
      content: 'Please contact our customer support, 13333',
      title: 'Sorry, new loan application is currently not available'
    },
    notAuthorized: {
      content: 'Nemate autorizaciju da pristupite ovom kreditu/zahtjevu za kredit. Molimo prijavite se.',
      title: 'Istekao je resurs'
    },
    otpMaxRetriesExceeded: {
      content: 'Molimo pokušajte ponovno.',
      title: 'Dosegnut je maksimalni broj nevalidnih pokušaja pristupa.'
    },
    phoneMissed: {
      content: 'Molimo posjetite neku od naših Podružnica radi ažuriranih informacija za korištenje aplikacije.',
      title: 'Neuspješna prijava'
    },
    remainingTimeOver: {
      content: 'Molimo pokušajte ponovno.',
      title: 'Dostignut je Timeout'
    },
    signing: {
      content: 'Molimo kontaktirajte našu podršku za klijente na +387 33 257 666 ili +387 51 981 330.',
      title: 'Ne mogu potpisati ugovor'
    },
    technical: {
      content: 'Molimo pokušajte ponovno kasnije',
      title: 'Žao nam je, došlo je do greške'
    }
  },
  validation: {
    currency: 'Neispravan iznos u BAM',
    email: 'Molimo unesite ispravnu e-mail adresu',
    iban: 'Please enter a valid IBAN',
    invalid: 'Netačna vrijednost',
    'local-bank-account': 'Please input correct bank account',
    max_date: 'Datum mora biti raniji od današnjeg',
    max_value: 'Vrijednost mora biti manja od {max}',
    min_value: 'Vrijednost mora biti veća od {min}',
    numeric: 'Dozvoljeni su samo brojevi za unos',
    no_decimals: 'Must be a number',
    pin: 'Molimo unesite Vaš Jedinstveni matični broj da biste nastavili',
    pin_empty: 'Molimo unesite vaš jedinstveni matični broj kako biste nastavili dalje',
    pin_invalid: 'Molimo osigurajte da ste unijeli Vaš Jedinstveni matični broj, a ne Vaš broj kredita',
    regex: 'Netačna vrijednost',
    required: 'Obavezno polje',
    valid_date: 'Datum nije validan'
  }
}
